import { render, staticRenderFns } from "./EventOrganizer.vue?vue&type=template&id=1662c032"
import script from "./EventOrganizer.vue?vue&type=script&lang=js"
export * from "./EventOrganizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports